import Config from '@/services/config.service.js';


const ID_TOKEN_KEY = 'GLSID';
const TOKEN_MAX_AGE = 60 * 60 * 24 * 1; // one day

const jwtService = {
  loadSessionToken,

  sessionToken: loadSessionToken(),

  getSessionToken() {
    const token = this.loadSessionToken();
    if (token) {
      this.checkSessionToken(token);
      return token;
    }
    return null;
  },

  getApiKey() {
    return sessionStorage.getItem(ID_TOKEN_KEY);
  },

  saveSessionToken(token) {
    this.sessionToken = token;
    document.cookie = `${ID_TOKEN_KEY}=${token}; max-age=${TOKEN_MAX_AGE}; domain=${Config.DOMAIN}; path=/; SameSite=None; Secure`;
  },

  saveApiKey(token) {
    sessionStorage.setItem(ID_TOKEN_KEY, token);
  },

  destroyApiKey() {
    sessionStorage.removeItem(ID_TOKEN_KEY);
  },

  destroySessionToken() {
    this.sessionToken = null;
    document.cookie = `${ID_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${Config.DOMAIN}; path=/; SameSite=None; Secure`;
  },

  destroyTokens() {
    this.destroySessionToken();
    this.destroyApiKey();
  },

  checkSessionToken(token) {
    if (this.sessionToken !== token) {
      this.destroyApiKey();
      location.reload();
    }
  },

  getTokenData(token) {
    if (!token) return {};
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        Buffer.from(base64, 'base64')
          .toString()
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      return {};
    }
  },

  isExpired(token) {
    const { exp = 0 } = this.getTokenData(token);
    const expirationDate = new Date(exp * 1000);
    return expirationDate.getTime() < Date.now();
  },
};

function loadSessionToken() {
  const cookie = document.cookie.split(';').find((item) => item.trim().startsWith(ID_TOKEN_KEY));
  if (cookie) {
    const token = cookie.split('=')[1];
    return token;
  }
  return null;
}

export default jwtService;
